module.exports = __webpack_public_path__ + "static/media/email-illustration.a1ad2491.svg";